export enum TypeOrderRequestEnum {
  CANCEL_ALL_ORDER = 'CANCEL_ALL_ORDER',
  CANCEL_ORDER = 'CANCEL_ORDER',
  EDIT_ALL_ORDER = 'EDIT_ALL_ORDER',
  EDIT_ORDER = 'EDIT_ORDER',
  SEND_ORDER = 'SEND_ORDER',
}
